import type React from 'react';

import { Alert, Text } from '@change/ds-core-ui';
import { TextField } from '@change/ds-forms';

import { Translate } from '@change-corgi/core/react/i18n';

import { useVanityModalState } from 'src/app/pages/starterDashboardV2/shared/hooks';

export const CreateVanityLinkSuccess: React.FC = () => {
	const [{ vanityUrl }] = useVanityModalState();

	return (
		<div className="flex w-full flex-col gap-6">
			<div className="flex flex-row items-center gap-2">
				<Text size="medium" className="leading-5">
					Change.org/
				</Text>
				<div className="flex-1">
					<TextField
						type="text"
						label="Custom URL"
						labelIsVisible={false}
						name="vanity-url-success-input"
						data-testid="vanity-url-success-input"
						isDisabled
						data-qa="vanity-url-success-input"
						value={vanityUrl}
						size="large"
					/>
				</div>
			</div>
			<Alert variant="success" className="[&>div]:p-3">
				<Text className="text-typography-success font-bold">
					<Translate value="corgi.petition.starter_dashboard_v2.grow_petition.copy_link.success_link_message" />
				</Text>
			</Alert>
		</div>
	);
};
